import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
import React from "react";

const ReportsWorkOrdersList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsWorkOrderList/ReportsWorkOrderList/ReportsWorkOrderList"
    )
);
export const ReportsWorkOrdersListPage = () => {
  return (
    <Layout>
      <ReportsWorkOrdersList />
    </Layout>
  );
};
